<div [formGroup]="form">
  <app-control codeLabel="titreId" class="col-12 col-xl-2">
    <ng-select [items]="membreService.civiliteList$ | async" formControlName="titreId" bindValue="valeur" bindLabel="text"> </ng-select>
  </app-control>
  <app-control codeLabel="nom" class="col-12 col-xl-5">
    <input type="text" formControlName="nom" class="form-control" />
  </app-control>

  <app-control codeLabel="prenom" class="col-12 col-xl-5">
    <input type="text" formControlName="prenom" class="form-control" />
  </app-control>

  <button type="button" class="btn btn-primary position-relative" [disabled]="!form.valid || saving" (click)="save()">
    @if (saving) {
      <app-button-spinner></app-button-spinner>
    }
    Enregistrer
  </button>
</div>
